import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewCity,
  viewCountry,
  viewState,
} from "../../Redux/Actions/settingsActions";
import AddImage from "../../Global Functions/addImage";
import TextInput from "../../Global Functions/textInput";
import ImageShowerModalGlobal from "../../Global Functions/imageShowerModalGlobal";

const AddCity = () => {
  const { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { country } = useSelector((state) => state.country || {});
  const { stateData } = useSelector((state) => state.states || {});

  const [cityData, setCityData] = useState({
    city_name: "",
    state: "",
    country: "",
    image: "",
    description: "",
    is_vr_home_visit_available: false,
    is_Popular: false,
  });

  useEffect(() => {
    if (id) {
      dispatch(viewState(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (Array.isArray(stateData?.data) && stateData.data.length > 0) {
      console.log("Loaded state data:", stateData.data);
      const state = stateData.data[0];
      setCityData((prev) => ({ ...prev, state: state._id, country: state.country }));
      dispatch(viewCountry(state.country));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateData]);

  useEffect(() => {
    // Only set country if not already set, to avoid overwriting
    if (
      !cityData.country &&
      Array.isArray(country?.data) &&
      country.data.length > 0
    ) {
      setCityData((prev) => ({ ...prev, country: country.data[0]._id }));
    }
  }, [country, cityData.country]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log("Submitting city data:", cityData);
    try {
      const response = await dispatch(addNewCity(cityData));
      if (response.statusCode === 200) {
        navigate(`/city/${cityData.state}`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleImageUpload = async (event) => {
    const uploadedImage = event.target.files[0];
    if (!uploadedImage) return;
    const imageUrl = await AddImage(uploadedImage);
    if (imageUrl) {
      setCityData((prevData) => ({ ...prevData, image: imageUrl }));
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setCityData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleToggleChange = (fieldName) => {
    setCityData((prevData) => ({
      ...prevData,
      [fieldName]: !prevData[fieldName]
    }));
  };

  return (
    <MainLayout>
      <div
        style={{
          background: "white",
          borderRadius: "25px",
          gridColumn: "2/7",
          minWidth: "100%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "0px 20px",
            alignItems: "center",
          }}
        >
          <h1>Add City</h1>

          <button onClick={() => navigate(-1)} className="button-class">
            View City List
          </button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label="Country"
                disabled={true}
                value={country?.data?.country_name || "N/A"}
              />
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label="State"
                disabled={true}
                value={
                  Array.isArray(stateData?.data)
                    ? stateData.data[0].state_name
                    : []
                }
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "10px",
              marginTop: "10px",
              justifyContent: "space-around",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                placeholder="Enter Name"
                label="City Name"
                name="city_name"
                value={cityData.city_name}
                onChange={handleAddChange}
              />
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                placeholder="Enter Description"
                label="Description"
                name="description"
                value={cityData.description}
                onChange={handleAddChange}
              />
            </div>
          </div>

          {/* Toggle Fields Section - Matching EditCity UI */}
          <div className="flex-container flex-justify-between gap-10" style={{ padding: "0 3%", marginTop: "20px" }}>
            {/* VR Home Visit Toggle */}
            <div style={{ width: "48%" }}>
              <div style={{ alignItems: "center", gap: "20px" }}>
                <div
                  style={{
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  {cityData.is_vr_home_visit_available ? "VR Available" : "VR Not Available"}
                </div>
                <label
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "50px",
                    height: "26px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={cityData.is_vr_home_visit_available}
                    onChange={() => handleToggleChange('is_vr_home_visit_available')}
                    style={{
                      opacity: 0,
                      width: 0,
                      height: 0,
                      position: "absolute",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: cityData.is_vr_home_visit_available ? "#08a600" : "#ccc",
                      borderRadius: "26px",
                      transition: "0.4s",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      left: cityData.is_vr_home_visit_available ? "24px" : "2px",
                      top: "2px",
                      width: "22px",
                      height: "22px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      transition: "0.4s",
                      boxShadow: "0 0 2px rgba(0,0,0,0.2)",
                    }}
                  />
                </label>
              </div>
            </div>

            {/* Popular Toggle */}
            <div style={{ width: "48%" }}>
              <div style={{ alignItems: "center", gap: "20px" }}>
                <div
                  style={{
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  {cityData.is_Popular ? "Is Popular" : "Not Popular"}
                </div>
                <label
                  style={{
                    position: "relative",
                    display: "inline-block",
                    width: "50px",
                    height: "26px",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={cityData.is_Popular}
                    onChange={() => handleToggleChange('is_Popular')}
                    style={{
                      opacity: 0,
                      width: 0,
                      height: 0,
                      position: "absolute",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: cityData.is_Popular ? "#08a600" : "#ccc",
                      borderRadius: "26px",
                      transition: "0.4s",
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      left: cityData.is_Popular ? "24px" : "2px",
                      top: "2px",
                      width: "22px",
                      height: "22px",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      transition: "0.4s",
                      boxShadow: "0 0 2px rgba(0,0,0,0.2)",
                    }}
                  />
                </label>
              </div>
            </div>
          </div>

          <div
            style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "20px" }}
          >
            <div style={{ width: "50%" }}>
              <span>Add Image</span>
              <input
                className="input-class"
                id="image"
                style={{ display: "none" }}
                onChange={handleImageUpload}
                type="file"
              />
              <label className="label-class-image" htmlFor="image">
                Click to Upload Image
              </label>
              <ImageShowerModalGlobal
                file={cityData.image}
                state={cityData}
                setState={setCityData}
                keyField="image"
              />
            </div>
          </div>
          <div className="flex-end margin-h-10">
            <button onClick={() => navigate(-1)} className="button-class-white">
              Cancel
            </button>
            <button type="submit" className="button-class">
              Save
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddCity;
